import { render, staticRenderFns } from "./guidingWay.vue?vue&type=template&id=2dd7d7cd&"
import script from "./guidingWay.vue?vue&type=script&lang=js&"
export * from "./guidingWay.vue?vue&type=script&lang=js&"
import style0 from "./guidingWay.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports